<template>
  <div style="position: relative">
    <!-- "Used on X Players' Badge -->
    <div
      v-if="channel.num_decoders_active_on > 0"
      class="used-on-decoders-badge clickable"
    >
      <v-chip
        :title="numDecodersActiveOnInfo"
        color="msr"
        class="title pa-1 white--text elevation-16 clickable"
      >
        <v-layout align-center>
          <v-icon class="mr-2">
            radio
          </v-icon>
          {{ channel.num_decoders_active_on }}
        </v-layout>
      </v-chip>
    </div>
    <!-- 'New' Badge -->
    <img
      v-if="channel.is_new"
      class="is-new-badge"
      :src="$store.state.common.newBadgeURL"
    >
    <v-card
      :hover="$vuetify.breakpoint.lgAndUp"
      flat
    >
      <v-img
        v-if="channel.cover"
        :src="channel.cover"
      />
      <v-card-text v-else>
        <v-layout
          column
          align-center
        >
          <v-icon class="placeholder">
            music_note
          </v-icon>
          <span class="subheading grey--text text--darken-3">{{
            channel.name
          }}</span>
        </v-layout>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  props: {
    channel: {
      type: Object,
      required: true,
    },
  },
  computed: {
    numDecodersActiveOnInfo() {
      const num = this.channel.num_decoders_active_on;
      if (!num) {
        return null;
      }
      const template = this.$t('radioChannelNumDecodersActiveOn');
      let text = template.replace('{{ num }}', num);
      // Hacky way to singularize the translation for en/de.
      if (num === 1) {
        text = text.replace('Playern', 'Player').replace('Players', 'Player');
      }
      return text;
    },
  },
};
</script>

<style scoped>
.is-new-badge {
  position: absolute;
  top: -2px;
  right: -2px;
  z-index: 1;
}
.is-new-badge:hover {
  cursor: pointer;
}

.used-on-decoders-badge {
  position: absolute;
  top: 8px;
  left: 8px;
  z-index: 1;
  user-select: none;
}
.used-on-decoders-badge:hover {
  cursor: pointer;
}

.placeholder {
  font-size: 10rem;
  width: 100%;
  height: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/RadioChannelCard.vue